export enum PaymentMethod {
  Cash = 0,
  PaymentCard = 1,
  Bluecode = 2,
  GiftCard = 3
}
